<template>
  <div class="alarmTemplate">
    <div class="title">
      <p>
        <span>告警模版</span>
      </p>
    </div>
    <!--列表-->
    <div class="content">
      <div class="contain">
        <!--新增模版-->
        <el-button class="addBtn" type="primary" @click="addClick">
          <el-icon>
            <Plus/>
          </el-icon>
          新增模版
        </el-button>
        <!--模版列表-->
        <el-table v-loading="loading" :data="tableData" style="width: 100%">
          <template #empty>
            <el-empty class="emptyClass" description="暂无数据信息"
                      image="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/emptyImg.png">
            </el-empty>
          </template>
          <el-table-column label="模版名称" prop="name"></el-table-column>
          <el-table-column label="创建时间" prop="createTime"></el-table-column>
          <el-table-column label="创建人" prop="creatorName"></el-table-column>
          <el-table-column label="告警规则" prop="targetDList">
            <template #default="scope">
              <p v-for="(item,index) in scope.row.targetDList" :key="index">
                <span v-if="item.level===1" class="level level1">{{ item.levelStr }}</span>
                <span v-if="item.level===2" class="level level2">{{ item.levelStr }}</span>
                <span v-if="item.level===3" class="level level3">{{ item.levelStr }}</span>
                <span v-if="item.level===4" class="level level4">{{ item.levelStr }}</span>
                <span v-if="item.level===5" class="level level5">{{ item.levelStr }}</span>
                {{ item.dictName }}{{ item.symbol }}{{ item.value }}
              </p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120px">
            <template #default="scope">
              <div class="opacity">
                <span class="editClass btn" @click.prevent="editClick(scope.row.id,scope.row)">编辑</span>
                <span class="editClass delBtn" @click.prevent="delClick(scope.row.id,scope.row)">删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="tableData.length>0" class="pag">
          <el-pagination v-model:page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :total="total" background
                         layout="total,sizes,prev, pager, next" @size-change="handleSizeChange"
                         @current-change="pageChange"/>
        </div>
      </div>
    </div>
    <!--弹窗-->
    <el-dialog v-model="dialogFormVisible" :close-on-click-modal="false" :title="formData.id?'编辑模版':'新建模版'"
               width="60%">
      <el-form ref="fromRef" :inline="true" :model="formData" :rules="formRules">
        <el-form-item label="模版名称:" prop="name">
          <el-input v-model="formData.name" placeholder="请输入模版名称"></el-input>
        </el-form-item>
        <div v-for="(item,index) in formData.targetJsonStr" :key="index" class="rowItem">
          <el-form-item :prop="`targetJsonStr[${index}].level`" >
            <el-select v-model="item.level" class="item" clearable placeholder="请选择告警级别">
              <el-option :value="1" label="紧急告警"></el-option>
              <el-option :value="2" label="主要告警"></el-option>
              <el-option :value="3" label="次要告警"></el-option>
              <el-option :value="4" label="警告告警"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :prop="`targetJsonStr[${index}].productId`" >
            <el-select v-model="item.productId" class="item" clearable filterable
                       placeholder="请选择产品类型" @change="productChange(item, index)" 
                       :loading="productLoading">
              <el-option v-for="(product, idx) in productList" :key="idx" :label="product.name"
                         :value="product.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :prop="`targetJsonStr[${index}].dictId`" >
            <el-select v-model="item.dictId" class="item" filterable placeholder="请选择监控指标" 
                       :loading="item.loading"
                       @change="handleDictChange(item, $event)">
              <el-option v-for="dict in item.dictList" :key="dict.id" :label="dict.name" >
                <span>{{ dict.name }}</span>
                <span v-if="dict.unit" style="float: right; color: #8492a6; font-size: 13px">
                  {{ dict.unit }}
                </span>
              </el-option>
              
              <!-- 如果没有数据时显示提示 -->
              <template v-if="item.dictList.length === 0 && !item.loading && item.productId">
                <div class="no-data-option">
                  暂无监控指标
                </div>
              </template>
              
              <!-- 如果有数据但没有匹配项，显示当前选中的值 -->
              <template v-if="item.dictId && item.dictList.length > 0 && !item.dictList.find(d => d.id == item.dictId)">
                <div class="current-value" style="padding: 8px 20px; color: #909399;">
                  当前值: {{ item.dictName || item.dictId }}
                </div>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item :prop="`targetJsonStr[${index}].symbol`" :rules="rules.symbol">
            <el-input v-model="item.value" class="item" placeholder="请输入告警值">
              <template #prepend>
                <el-select v-model="item.symbol" class="item" placeholder="请选择" style="width:100px" >
                  <el-option label=">" value=">"></el-option>
                  <el-option label="<" value="<"></el-option>
                  <el-option label="=" value="="></el-option>
                  <el-option label=">=" value=">="></el-option>
                  <el-option label="<=" value="<="></el-option>
                </el-select>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item :prop="`targetJsonStr[${index}].value`" :rules="rules.value">
            <!-- 这里不需要额外元素，因为value已经在上面的input中 -->
          </el-form-item>

          <el-icon v-if="formData.targetJsonStr.length>1" class="delIcon" @click="delItemClick(index)">
            <CircleClose/>
          </el-icon>
          <el-icon v-if="index===formData.targetJsonStr.length-1" class="addIcon" @click="addItemClick">
            <CirclePlus/>
          </el-icon>
        </div>
      </el-form>
      <template #footer>
      <span class="dialog-footer">
        <el-button class="cancle" @click="dialogFormVisible=false">取消</el-button>
        <el-button class="confrim" type="primary" @click="save()">保存</el-button>
      </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import {h, onMounted, reactive, ref, nextTick} from "vue"
import './alarmTemplate.less'
import {CloseBold, ZoomIn, Plus, Back, CircleClose, CirclePlus} from '@element-plus/icons-vue'
import {CascaderProps, ElMessage, ElMessageBox} from 'element-plus'
import {useRouter} from 'vue-router';
import qs from "qs";
import {
  delAlarmTemplateAPi,
  getAlarmTemplateListAPi,
  getIndexSelectAPi,
  saveAlarmTemplateAPi, getProductSelectApi, getDictSelectApi
} from "@/api/modules/alarm";
import {getList} from "@/api/modules/productCategory";

let router = useRouter()

// 模版列表-----------------------------------------------------------------
// 分页
let pageNumber = ref(1)
let pageSize = ref(20)
let total = ref(0)
// 更改每页多少
const handleSizeChange = function (e) {
  pageSize.value = e
  getListFun()
}
// 跳转到某页
const pageChange = function (e) {
  pageNumber.value = e
  getListFun()
}
// 表格数据
let tableData = ref([])
// 获取表格数据
let loading = ref(false)
const getListFun = function () {
  loading.value = true
  getAlarmTemplateListAPi(qs.stringify({
    pageNumber: pageNumber.value,
    pageSize: pageSize.value
  })).then(res => {
    loading.value = false
    if (res.data.code === 0) {
      tableData.value = res.data.result.list
      total.value = Number(res.data.result.total)
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    loading.value = false
    console.log(err);
  })
}

// 新增编辑-----------------------------------------------------------------
// 新增编辑弹窗
let dialogFormVisible = ref(false)
// 产品列表
let productList = ref([])
let productLoading = ref(false)

// 获取产品列表
const getProductListFun = function () {
  productLoading.value = true
  getProductSelectApi().then(res => {
    productLoading.value = false
    if (res.data.code === 0) {
      productList.value = res.data.result
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    productLoading.value = false
    console.log(err);
  })
}

// 产品类型和指标映射缓存
let productDictCache = new Map()

// 获取某个产品的监控指标列表
const getDataListFun = async function (productId) {
  if (!productId) return []
  
  // 如果缓存中有，直接返回
  if (productDictCache.has(productId)) {
    return productDictCache.get(productId)
  }
  
  try {
    const res = await getDictSelectApi(qs.stringify({ productId }))
    if (res.data.code === 0) {
      productDictCache.set(productId, res.data.result)
      return res.data.result
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
      return []
    }
  } catch (err) {
    console.log('获取监控指标失败:', err)
    return []
  }
}

// 处理产品类型变化
const productChange = async (item, index) => {
  if (item.productId) {
    item.loading = true
    item.dictId = '' // 清空已选的监控指标
    item.dictName = '' // 清空指标名称
    
    const dictList = await getDataListFun(item.productId)
    item.dictList = dictList
    item.loading = false
  } else {
    item.dictId = ''
    item.dictName = ''
    item.dictList = []
  }
}

// 处理监控指标变化
const handleDictChange = (item, dictId) => {
  if (dictId && item.dictList) {
    const matchedDict = item.dictList.find(dict => dict.id == dictId)
    if (matchedDict) {
      item.dictName = matchedDict.name
    }
  } else {
    item.dictName = ''
  }
}

// 新增编辑表单数据
let formData = ref({
  id: 0,
  name: '',
  targetJsonStr: [
    {
      level: '',
      dictId: '',
      dictName: '',
      symbol: '',
      value: '',
      productId: '',
      dictList: [], // 存储监控指标列表
      loading: false
    }
  ]
})

// 表单验证规则
let rules = {
  name: [
    { required: true, message: '请输入模版名称', trigger: 'blur' }
  ],
  // level: [
  //   { required: true, message: '请选择告警级别', trigger: 'change' }
  // ],
  // productId: [
  //   { required: true, message: '请选择产品类型', trigger: 'change' }
  // ],
  // dictId: [
  //   { required: true, message: '请选择监控指标', trigger: 'change' }
  // ],
  // symbol: [
  //   { required: true, message: '请选择运算符', trigger: 'change' }
  // ],
  // value: [
  //   { required: true, message: '请输入告警值', trigger: 'blur' },
  //   { pattern: /^-?\d+(\.\d+)?$/, message: '请输入数字', trigger: 'blur' }
  // ]
}

// 表单规则
let formRules = ref({
  name: [
    {required: true, message: '请输入模版名称', trigger: 'blur'},
  ]
})

// 点击新增
const addClick = function () {
  dialogFormVisible.value = true
  formData.value = {
    id: 0,
    name: '',
    targetJsonStr: [
      {
        level: '',
        dictId: '',
        dictName: '',
        symbol: '',
        value: '',
        productId: '',
        dictList: [],
        loading: false
      }
    ]
  }
}

// 点击编辑
const editClick = async function (id, row) {
  console.log('编辑行数据:', row)
  console.log('targetDList:', row.targetDList)
  
  // 先关闭对话框
  dialogFormVisible.value = false
  
  // 清空缓存
  productDictCache = new Map()
  
  // 复制原始数据
  const targetJsonStr = JSON.parse(JSON.stringify(row.targetDList || []))
  console.log('复制后的targetJsonStr:', targetJsonStr)
  
  // 为每个告警规则项初始化
  for (let i = 0; i < targetJsonStr.length; i++) {
    const item = targetJsonStr[i]
    item.dictList = []
    item.loading = false
    
    console.log(`第${i}项:`, item)
    console.log('productId:', item.productId, 'dictId:', item.dictId, 'dictName:', item.dictName)
    
    // 如果有产品ID，加载对应的监控指标列表
    if (item.productId) {
      console.log(`正在加载第${i}项的监控指标, productId:`, item.productId)
      item.loading = true
      
      try {
        const dictList = await getDataListFun(item.productId)
        item.dictList = dictList
        item.loading = false
        
        console.log(`第${i}项监控指标列表:`, dictList)
        
        // 如果有dictId，找到对应的指标
        if (item.dictId && dictList.length > 0) {
          const matchedDict = dictList.find(dict => {
            // 使用==比较，兼容字符串和数字类型
            return dict.id == item.dictId
          })
          
          if (matchedDict) {
            item.dictName = matchedDict.name
            console.log(`第${i}项匹配到监控指标:`, matchedDict)
          } else {
            console.log(`第${i}项未找到匹配的监控指标, dictId=${item.dictId}`)
            console.log('可用指标:', dictList.map(d => ({id: d.id, name: d.name})))
          }
        }
      } catch (err) {
        item.loading = false
        console.error(`加载第${i}项监控指标失败:`, err)
      }
    }
  }
  
  formData.value = {
    id: row.id,
    name: row.name,
    targetJsonStr: targetJsonStr
  }
  
  console.log('formData设置后:', formData.value)
  
  // 如果没有告警规则，添加一个默认的
  if (formData.value.targetJsonStr.length === 0) {
    formData.value.targetJsonStr.push({
      level: '',
      dictId: '',
      dictName: '',
      symbol: '',
      value: '',
      productId: '',
      dictList: [],
      loading: false
    })
  }
  
  // 使用nextTick确保DOM更新
  await nextTick()
  
  // 打开对话框
  dialogFormVisible.value = true
  console.log('对话框已打开')
}

// 点击增加设备
const addItemClick = function () {
  formData.value.targetJsonStr.push({
    level: '',
    dictId: '',
    dictName: '',
    symbol: '',
    value: '',
    productId: '',
    dictList: [],
    loading: false
  })
}

// 点击删除设备
const delItemClick = function (index) {
  formData.value.targetJsonStr.splice(index, 1)
}

// 提交
let fromRef = ref()
const save = function () {
  if (!fromRef.value) return
  
  fromRef.value.validate((valid) => {
    if (valid) {
      // 检查告警规则是否填写完整
      let hasError = false
      let errorIndex = -1
      
      for (let i = 0; i < formData.value.targetJsonStr.length; i++) {
        const item = formData.value.targetJsonStr[i]
        if (!item.level || !item.productId || !item.dictId || !item.symbol || !item.value) {
          hasError = true
          errorIndex = i
          break
        }
      }
      
      if (hasError) {
        ElMessage({
          type: 'warning',
          message: `第${errorIndex + 1}行告警规则填写不完整`
        })
        return
      }
      
      // 准备提交数据
      let submitData = {
        id: formData.value.id,
        name: formData.value.name,
        targetJsonStr: JSON.stringify(formData.value.targetJsonStr.map(item => ({
          level: item.level,
          dictId: item.dictId,
          dictName: item.dictName || '', // 确保包含指标名称
          symbol: item.symbol,
          value: item.value,
          productId: item.productId
        })))
      }
      
      console.log('提交的数据:', submitData)
      
      // 提交数据
      saveAlarmTemplateAPi(qs.stringify(submitData)).then(res => {
        if (res.data.code === 0) {
          getListFun()
          dialogFormVisible.value = false
          ElMessage({
            type: 'success',
            message: '保存成功'
          })
        } else {
          ElMessage({
            type: 'error',
            message: res.data.message
          })
        }
      }).catch(err => {
        console.log(err)
        ElMessage({
          type: 'error',
          message: '保存失败'
        })
      })
    } else {
      ElMessage({
        type: 'warning',
        message: '请填写完整的表单信息'
      })
    }
  })
}

// 点击删除
const delClick = function (id, row) {
  ElMessageBox.confirm('请确认是否要删除此告警模版，删除后数据不可恢复', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    title: '删除模版',
    message: h('p', null, [
      h('img', {
        src: 'https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png',
        style: 'width:20px;height:20px;transform: translateY(4px);margin-right:8px;'
      }, ''),
      h('span', {style: 'color:#595959;'}, '请确认是否要删除此告警模版，删除后数据不可恢复'),
    ])
  }).then(() => {
    delAlarmTemplateAPi(qs.stringify({id: id})).then(res => {
      if (res.data.code === 0) {
        getListFun()
        ElMessage({
          type: 'success',
          message: '删除成功'
        });
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }).catch(() => {
    ElMessage({
      type: 'info',
      message: '已取消删除'
    });
  });
}

onMounted(() => {
  getProductListFun()
  getListFun()
})

</script>

<style lang="less" scoped>
// 添加一些样式来改善表单布局
// .rowItem {
//   display: flex;
//   align-items: center;
//   margin-bottom: 20px;
//   position: relative;
  
//   .el-form-item {
//     margin-right: 10px;
//   }
  
//   .item {
//     width: 200px;
//   }
  
//   .delIcon, .addIcon {
//     cursor: pointer;
//     font-size: 20px;
//     margin-left: 10px;
//   }
  
//   .delIcon {
//     color: #f56c6c;
//   }
  
//   .addIcon {
//     color: #409eff;
//   }
// }
</style>